"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Course/components/Activities.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Card_Activity_template = require("../../../../../../components/Card-Activity.marko"),
    Card_Activity_tag = marko_loadTag(Card_Activity_template),
    marko_attrs0 = {
        id: "activities"
      },
    marko_attrs1 = {
        "class": "mt-4"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("h6", null, "1", component);

  Locale_tag({
      text: "Activities"
    }, out, __component, "2");

  out.ee();

  out.be("div", marko_attrs1, "3", component);

  Card_Activity_tag({
      name: "C/C++ Language Program",
      subject: "Evaluation course",
      icon: "bx-sitemap",
      link: "/programs/:id"
    }, out, __component, "4");

  Card_Activity_tag({
      name: "Designer's Meeting",
      status: "Started 4min ago",
      icon: "bx-slideshow",
      link: "/meetings/:id"
    }, out, __component, "5");

  Card_Activity_tag({
      name: "Conversation on V8 Engine",
      subject: "Forum Channel",
      icon: "bx-conversation",
      toggle: "chat:id"
    }, out, __component, "6");

  Card_Activity_tag({
      name: "Knowledge Champion Game",
      status: "5 Star reward",
      icon: "bx-book-bookmark",
      link: "/games/:id"
    }, out, __component, "7");

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
